import React from 'react';

import {
  ERROR_MESSAGES,
  TITLE,
} from 'root/apps/QuoteMachineIntegration/components/PaymentRequest/TotalsSection/messages';
import {
  RegisterTitleText,
  RegisterTitleWrapper,
  WorkOrderTitleText,
  WorkOrderTitleWrapper,
} from 'root/apps/QuoteMachineIntegration/components/PaymentRequest/TotalsSection/styles';
import WarningTooltip from 'root/apps/QuoteMachineIntegration/WarningTooltip';

type Props = {
  onRegisterPage?: boolean;
  showWarning?: boolean;
};
export const PaymentRequestTotalsTitle: React.FC<Props> = ({ onRegisterPage, showWarning }) => {
  // choose title styles based on page (register or work order)
  const TitleWrapper = onRegisterPage ? RegisterTitleWrapper : WorkOrderTitleWrapper;
  const TitleText = onRegisterPage ? RegisterTitleText : WorkOrderTitleText;

  return (
    <TitleWrapper>
      <TitleText>
        {showWarning && <WarningTooltip content={ERROR_MESSAGES.FETCH_ALL_PAY_REQS_TOTAL_ERROR} />}
        {TITLE}
      </TitleText>
    </TitleWrapper>
  );
};
